import { useEffect, useState } from "react";
import { CheckCircle2, Mail } from "lucide-react";
import { api } from "@/lib/api";

function fmt(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export default function History() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/readings")
      .then(setList)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen p-6 md:p-10">
      <header className="mb-8">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-soma-brand">// your rituals</p>
        <h1 className="mt-1 font-display text-4xl font-medium text-soma-on">Reading History</h1>
      </header>

      {loading ? (
        <div className="space-y-3">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-20 animate-pulse rounded-2xl bg-soma-surface2" />
          ))}
        </div>
      ) : list.length === 0 ? (
        <div className="rounded-2xl border border-soma-border bg-soma-surface2 p-16 text-center">
          <p className="text-soma-muted">No readings yet. Your first ritual starts on the Hub.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {list.map((r) => (
            <div
              key={r.id}
              data-testid={`history-row-${r.id}`}
              className="flex items-center justify-between rounded-2xl border border-soma-border bg-soma-surface2 p-5"
            >
              <div className="min-w-0">
                <p className="truncate font-medium text-soma-on">{r.client_name || "Anonymous seeker"}</p>
                <p className="text-xs capitalize text-soma-muted">
                  {r.mode} · {fmt(r.created_at)}
                </p>
              </div>
              <div className="flex items-center gap-3">
                {r.report_sent && (
                  <span title="Report sent" className="text-soma-brand">
                    <Mail size={16} />
                  </span>
                )}
                <span
                  className={`flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] ${
                    r.is_paid ? "bg-soma-success/25 text-soma-on" : "bg-soma-surface3 text-soma-muted"
                  }`}
                >
                  {r.is_paid && <CheckCircle2 size={12} />}
                  {r.is_paid ? "Paid" : "Free"}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
